export default {
  'LOCATION NAME': {
    field: "name",
    multiple: false,
  },
  OWNER: {
    field: "owner",
    multiple: false,
  },
  STREET: {
    field: "street",
    multiple: false,
  },
  CITY: {
    field: "city",
    multiple: false,
  },
  STATE: {
    field: "state",
    multiple: false,
  },
  ZIP: {
    field: "zip",
    multiple: false,
  },
}